export class MaterialDataDomain {
  public constructor(
    public material: string,
    public responsibleUser: string,
    public mainGroupTop: string
  ) {}
}
